// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1kgMT","label":"Radio_label__1hMvg","checkMark":"Radio_checkMark__1uOdv","disabled":"Radio_disabled__39WzR"};